export enum EntityType {
  Asset = 'Asset',
  Job = 'Job',
  Client = 'Client',
  Lease = 'Lease',
}
